import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import { fmtRemaining } from "@/lib/format";
import { watchPath } from "@/lib/play";

export const ContinueCard = ({ item, fluid = false }) => {
  const navigate = useNavigate();
  const { title, episode } = item;
  const pct = Math.min(100, Math.round((item.progress || 0) * 100));
  const label = episode ? `S${episode.season}:E${episode.number} · ${episode.title}` : title.title;
  return (
    <div
      role="link"
      tabIndex={0}
      data-testid={`continue-card-${title.slug}`}
      onClick={() => navigate(watchPath(title.slug, episode?.id))}
      onKeyDown={(e) => e.key === "Enter" && navigate(watchPath(title.slug, episode?.id))}
      className={`group flex-none cursor-pointer snap-start ${fluid ? "w-full" : "w-[264px] min-[400px]:w-[284px] sm:w-[312px] lg:w-[360px]"}`}
    >
      <div className="relative aspect-video overflow-hidden rounded-lg border border-[#D4AF37]/20 bg-[#0B0B0D] shadow-[0_10px_28px_rgba(0,0,0,0.7)] transition-[transform,border-color,box-shadow] duration-500 active:scale-[0.98] md:group-hover:scale-[1.04] md:group-hover:border-[#FFD86A]/80 md:group-hover:shadow-[0_0_22px_rgba(212,175,55,0.22)]">
        <img src={title.backdrop_url} alt={title.title} loading="lazy" decoding="async" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
        <span className="absolute inset-0 m-auto grid h-12 w-12 place-items-center rounded-full border border-[#FFD86A]/70 bg-[#050505]/55 text-[#FFD86A] backdrop-blur transition-[transform,opacity] duration-300 md:opacity-0 md:group-hover:opacity-100 group-hover:scale-110">
          <Play className="h-5 w-5 fill-current ml-0.5" />
        </span>
        <div className="absolute inset-x-0 bottom-0 px-3 pb-2.5">
          <p className="font-display text-sm font-bold tracking-[0.04em] text-white truncate">{title.title}</p>
          <div className="mt-0.5 flex items-center justify-between gap-2 text-[0.75rem] text-white/70">
            <span className="truncate">{label}</span>
            <span data-testid={`continue-remaining-${title.slug}`} className="flex-none font-semibold text-[#F5C451]">{item.position > 0 ? fmtRemaining(item.remaining_sec) : "Up next"}</span>
          </div>
          <div className="mt-2 h-[3px] w-full overflow-hidden rounded-full bg-white/15">
            <div data-testid={`continue-progress-${title.slug}`} className="h-full rounded-full bg-gradient-to-r from-[#D4AF37] via-[#F5C451] to-[#FFD86A]" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};
